<template>
    <div class="similar_funs_collapse-container" :class="{open : !isOpen, no_fans: countSimilarFans == 0, disabled_after_offer: !isEditable}">

        <div @click="isOpen = !isOpen" class="title-container">
            <h2 class="title">{{translate("selected_fans")}} <span class="amount">({{countSimilarFans}})</span></h2>
            <div class="plus_icon"></div>
        </div>
        <ol class="elements-container">
            <li v-if="getSimilarFans" v-for="element in getSimilarFans" class="element" :class="{activeFan: getActiveFun.model == element.model}"
                @click="selectFanRowAsActiveInFansTable(element)">
                <span class="name">{{element.type}} </span>
                <span class="param">{{element.model}}</span>
                <span v-if="printElementInfo(element) != null && printElementInfo(element) > 0"
                      class="amount" >{{printElementInfo(element)}} {{translate('szt')}}</span>
            </li>
        </ol>
    </div>
</template>

<script>
    export default {
        name: "SimilarProductsCollapse",
        data() {
            return {
                isOpen: false,
                isNone: true
            }
        },
        methods: {
            printElementInfo(element) {
                if (this.$store.state.selectedSecondStepElement.multiple_fans == 1 && element.data['number_of_fans'] && element.data['number_of_fans'] > 0) {
                    return element.data['number_of_fans'];
                } else {
                    return null;
                }
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                };

                this.$store.commit(arg);

                return arg.out;

            },
            selectFanRowAsActiveInFansTable(fan) {
                let fanObj = {
                    type: 'selectFanRowAsActiveInFansTable',
                    fan_id: fan.id,
                    reset_params: true,
                };

                if(this.printElementInfo(fan) != null && this.printElementInfo(fan) > 0)
                {
                    fanObj.count = this.printElementInfo(fan);
                }

                this.$store.commit(fanObj);
            },

            manageSelectedFan() {
                this.$store.commit({
                    type: 'manageSelectedFan',
                });
            }
        },
        computed: {
            isEditable() {
                return this.$store.getters.isOfferEditable;
            },

            getActiveFun() {
                return this.$store.state.activeFun;
            },

            getSimilarFans() {
                if (this.$store.state.fansTableData.FanTableRef)
                    return this.$store.state.fansTableData.FanTableRef.allFilteredData;
                else
                    return null;
            },
            countSimilarFans() {
                this.manageSelectedFan();

                if (this.$store.state.fansTableData.FanTableRef)
                    return this.$store.state.fansTableData.FanTableRef.allFilteredData.length;
                else
                    return 0;
            }
        }
    }
</script>